import { useQuery } from "@tanstack/react-query";
import { getActiveTrackStages } from "../api";

export const useActiveTrackStages = (trackTypeId?: number) => {
  const query = useQuery({
    queryKey: ["active-track-stages",trackTypeId],
    queryFn: () => {
      if (!trackTypeId) return undefined;
      return getActiveTrackStages(trackTypeId);
    },
    enabled: !!trackTypeId,
  });

  return {
    ...query,
    data: query.data?.data,
  };
};
